import { TypographyProps } from '@components/Typography';
import styled from 'styled-components';

export const FooterRootContainer = styled.div`
  // background-color: #f5f5f5;
  background-color: #f3fcfe;
  font-family: proxima-nova, sans-serif;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    margin-top: 0rem;
    padding: 3rem 1rem;
  }
`;

export const FooterContainer = styled.div`
  max-width: 143rem;
  margin: 0 auto;
  padding-top: 2rem;

  font-family: proxima-nova, sans-serif;
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size16};
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

export const FooterContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;

  border-bottom: 1px solid ${({ theme }) => theme.color.greyMedium};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
  }
`;

export const FooterLinksContainer = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.25rem;
  padding-top: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
    gap: 1.875rem;
    padding: 0;
  }
`;

export const Logo = styled.img`
  width: 26.73rem;
  height: 8.3rem;
  object-fit: contain;

  margin-bottom: 0.625rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    justify-content: left;
    width: 19.7rem;
    height: 6.4rem;
  }
`;

export const CompanyDescriptionContainer = styled.div`
  display: flex;
  justify-content: left;
  position: relative;
  padding-top: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    justify-content: start;
    padding-top: 1rem;
    margin-bottom: 4rem;
  }
`;

export const CompanyDescription = styled.p`
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};
  max-width: 286px;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size16};
    max-width: 100%;
  }
`;

export const Column = styled.div`
  padding-top: 3.125rem;
  text-align: left;
  padding-bottom: 1.875rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    border-bottom: 2px solid ${({ theme }) => theme.color.white};
    padding-top: 0;
    padding-bottom: 2rem;

    &[data-section='what-we-do'],
    &[data-section='the-company'] {
      display: block;
    }

    &[data-section='what-we-do'] .link-items-inline,
    &[data-section='the-company'] .link-items-inline {
      display: inline;
      white-space: normal;
      line-height: 1.6;
    }
  }
`;

export const ColumnLogo = styled.div`
  text-align: left;
  padding-top: 6.125rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    border-bottom: 2px solid ${({ theme }) => theme.color.white};
    margin-bottom: 1.9375rem;
    padding-top: 4rem;
    text-align: left;
  }
`;

export const ColumnTitle = styled.h4`
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size20};
  font-weight: bold;
  padding-bottom: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};
  }
`;

export const SocialLinkColumnTitle = styled.h4`
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};
  font-family: proxima-nova, sans-serif;
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size20};
  font-weight: bold;
  margin-bottom: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};
    margin-top: 2rem;
    text-align: left;
  }
`;

export const LinkItem = styled.p`
  cursor: pointer;
  font-family: proxima-nova, sans-serif;
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};

  padding-bottom: 1.25rem;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    line-height: ${({ theme }) => theme.lineHeight.height150};
    display: inline-block;

    ${Column}[data-section='what-we-do'] &,
    ${Column}[data-section='the-company'] & {
      display: inline;
      margin-right: 0.25rem;

      &::after {
        content: ' • ';
        margin-left: 0.25rem;
      }

      &:last-child::after {
        content: '';
      }
    }
  }
`;

export const ContactInfo = styled.p`
  display: flex;
  gap: 1rem;
  padding-bottom: 1rem;
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 4rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    text-align: left;
    justify-content: start;
    width: 100%;
    margin-bottom: 4rem;
  }
`;

export const TermsAndCopyrightsContainer = styled.div`
  color: ${({ theme }) => theme.color.mobilityGrey};

  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 2rem;

  padding-top: 4rem;
  padding-bottom: 4rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    padding-bottom: 2rem;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-flow: wrap;
  }
`;

export const FootNoteOption = styled.span`
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size14};
  }
`;

export const CopyrightText = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    padding-top: 1.9375rem;
    text-align: left;
  }
`;
